import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["templateSelect", "sourceableSelect", "sourceableTypeInput"]
  static values = { url: String }

  connect() {}

  updateSourceableOptions() {
    const templateId = this.templateSelectTarget.value;
    if (!templateId) return;

    fetch(`${this.urlValue}?document_template_id=${templateId}`, {
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
    .then(response => response.json())
    .then(data => {
      const sourceableSelect = this.sourceableSelectTarget;
      const sourceableType = this.sourceableTypeInputTarget;

      sourceableSelect.removeAttribute('disabled');
      sourceableSelect.innerHTML = '<option value="">Fonte...</option>';

      data.options.forEach(option => {
        const optionElement = document.createElement('option');
        optionElement.value = option.id;
        optionElement.textContent = option.name;
        sourceableSelect.appendChild(optionElement);
      });

      if (data.entity_type) {
        sourceableType.value = data.entity_type;
      }

      if (data.hidden) {
        const firstNonEmptyOption = Array.from(sourceableSelect.options).find(option => option.value !== "");
        if (firstNonEmptyOption) {
          firstNonEmptyOption.selected = true;
        }
      }
    });
  }
}